import React, { useContext, useState, useEffect } from 'react';
import styled from 'styled-components';
import { AuthContext } from '../../../contexts/AuthContext';
import ENDPOINT from '../../../globals/api-endpoint';
import { Redirect } from 'react-router-dom';
import { Helmet } from 'react-helmet';

const InfoContainer = styled.div`
	padding: 15px;
	border: 1px solid ${props => props.theme.green};
	border-radius: 5px;
	margin: 20px 0;
`;

const H3 = styled.h3`
	text-align: center;
`;

const Information = styled.div`
	display: block;
`;

const B = styled.h4``;

const UserInfo = ({userId}) => {
	const { auth, dispatch } = useContext(AuthContext);
	const [token, setToken] = useState({
		authToken: localStorage.getItem('authToken')
	});
	const [isLoading, setIsLoading] = useState(true);
	const localToken = JSON.parse(token.authToken);
	const tokenFromStorage = localToken ? (localToken.token) : (null);
	const [userInfo, setUserInfo] = useState({});

	useEffect(() => {
		setToken({
			authToken: localStorage.getItem('authToken')
		});
	}, []);

	useEffect(() => {
		const fetchData = () => { 
			setIsLoading(true);
			fetch(ENDPOINT.CHECK_AUTH, {
				headers: {
					Authorization: tokenFromStorage
				}
			})
			.then(res => res.json())
			.then(res => {
				if (res.message === 'Auth succesful') {
					dispatch({ type: 'SWITCH_AUTH', auth: true,  uid: res.userId });
				} else {
					dispatch({ type: 'SWITCH_AUTH', auth: false });
				}
			})
			.catch(err => {
				console.log(err);
			})
			.finally(res => {
				setIsLoading(false);
			});
		}
		fetchData();
	}, [dispatch, tokenFromStorage]);

	useEffect(() => {
		const fetchData = () => {
			fetch(ENDPOINT.GET_PROFILE + userId)
			.then(res => res.json())
			.then(res => {
				setUserInfo(res.user);
			})
			.catch(err => {
				console.log(err);
			})
		}
		fetchData();
	}, [userId])

	
	if (auth.uid === userId) {
		return <Redirect to={'/me'} />
	}

	if (isLoading) {
		return null;
	} else {
		return(
			<InfoContainer>
				<Helmet>
					<title>{String(userInfo.name)} | bantuin</title>
				</Helmet>
				<H3>Informasi</H3>
				<Information>
					<B>{userInfo.name}</B>
					<B>{userInfo.headline ? (userInfo.headline) : (null)}</B>
					<p>Portfolio : {userInfo.portfolio ? (<a href={userInfo.portfolio}>{userInfo.portfolio}</a>) : (null)}</p>
					<p>Tentang : {userInfo.about ? (userInfo.about) : (null)}</p>
					<p>Contact : {userInfo.contact ? (userInfo.contact) : (null)}</p>
					<p>Whatsapp : {userInfo.whatsapp ? (userInfo.whatsapp) : (null)}</p>
				</Information>
			</InfoContainer>
		);
	}
}

export default UserInfo;